import { deepEquals } from 'app/infrastructure/js';
import { ListBranch, ListBranchState } from '../types-store';
import { RowSelection } from '../types';

interface RowRangeResult {
  range: number[][];
  rangeStartFound: boolean;
  rangeEndFound: boolean;
}

const getRowRange = (
  listBranch: ListBranch[],
  listBranchState: ListBranchState[],
  rootBranch: ListBranch,
  id1: number,
  id2: number,
  path: number[] = [],
  rangeStartFound: boolean = false
): RowRangeResult => {

  return rootBranch?.items.reduce(
    (result, item) => {

      if (result.rangeEndFound) {
        return result;
      }

      const currentPath = [...path, item.id];

      if (result.rangeStartFound && (item.id === id1 || item.id === id2)) {
        return {
          range: [...result.range, currentPath],
          rangeStartFound: true,
          rangeEndFound: true
        };
      }

      const currentRangeStartFound = result.rangeStartFound || item.id === id1 || item.id === id2;
      const currentChildBranch = listBranchState?.some(branch => branch.id === item.id && branch.open)
        ? listBranch?.find(branch => branch.id === item.id)
        : undefined;

      const childRange = currentChildBranch
        ? getRowRange(listBranch, listBranchState, currentChildBranch, id1, id2, currentPath, currentRangeStartFound)
        : undefined;

      return childRange
        ? {
          range: [
            ...result.range,
            ...(currentRangeStartFound ? [currentPath] : []),
            ...childRange.range
          ],
          rangeStartFound: childRange.rangeStartFound,
          rangeEndFound: childRange.rangeEndFound
        }
        : {
          range: currentRangeStartFound
            ? [
              ...result.range,
              currentPath
            ]
            : [],
          rangeStartFound: currentRangeStartFound,
          rangeEndFound: false
        };
    },
    {
      range: [],
      rangeStartFound: rangeStartFound,
      rangeEndFound: false
    } as RowRangeResult);
};

export const appendRowSelection = (
  selectedRows: number[][],
  lastSelectedRow: number,
  listBranch: ListBranch[],
  listBranchState: ListBranchState[],
  selection: RowSelection
): number[][] => {

  if (selection?.range && selection.path?.length) {
    const rootBranch = listBranch?.find(branch => branch.id === 0);
    const rowRangeResult = getRowRange(listBranch, listBranchState, rootBranch,
      lastSelectedRow, selection.path[selection.path.length - 1]);
    const rowRange = rowRangeResult?.rangeStartFound && rowRangeResult?.rangeEndFound
      ? rowRangeResult.range
      : [];

    return selection.append
      ? [
        ...(selectedRows ?? []),
        ...rowRange.filter(row => !selectedRows?.some(selectedRow => deepEquals(row, selectedRow)))
      ]
      : rowRange;
  }

  if (selectedRows?.some(row => deepEquals(row, selection?.path))) {

    return selection.append
      ? selectedRows.filter(row => !deepEquals(row, selection.path))
      : [];
  }

  return selection?.append
    ? [
      ...(selectedRows ?? []),
      ...(selection.path ? [selection.path] : [])
    ]
    : selection?.path ? [selection.path] : [];
};
